export default __webpack_public_path__ + "static/media/profile.b5591477.svg";